/**
 * Defines the type of action to take when the trigger hits.
 * tag: 1101
 * @readonly
 * @enum {string} (char)
 */
export enum TriggerAction {
  /** Activate */
  Activate = '1',
  /** Modify */
  Modify = '2',
  /** Cancel */
  Cancel = '3',
}
